/*global jQuery */
/*jshint esversion: 6 */

void function themeStart($) {
    'use strict';

    function toggleCollapse($panel, expanding, suppressAccordion) {
        // based on https://github.com/paypal/bootstrap-accessibility-plugin/blob/a7c00a01a43d8199fc386274ccedbeda5bfece70/src/js/collapse.js
        if (expanding === undefined) {
            expanding = $panel.attr('aria-expanded') !== 'true';
        }

        if (expanding && !suppressAccordion) {
            const $accordion = $panel.closest('[role=tablist]');
            if ($accordion.length) {
                const $otherPanels = $accordion.find('[role=tabpanel]').not($panel);
                $otherPanels.each((i, panel) => toggleCollapse($(panel), false, true));
            }
        }

        const panelId = $panel.attr('id');
        const $toggles = $(`[aria-controls="${panelId}"]`);
        $toggles.attr('aria-expanded', expanding);
        $toggles.attr('aria-selected', expanding);
        $toggles.attr('tabIndex', expanding ? 0 : -1);

        $panel.attr('aria-expanded', expanding);
        $panel.attr('aria-hidden', !expanding);
        $panel.attr('tabIndex', expanding ? 0 : -1);
    }

    void function initializePanelToggle() {
        function findPanel($button) {
            const panelId = $button.attr('aria-controls');
            return $(`#${panelId}`);
        }

        const $toggles = $('.js-toggle');
        $toggles.each((i, toggleElement) => {
            const $button = $(toggleElement);
            toggleCollapse(findPanel($button), false);
        });
        $toggles.on('click', function handleClick(event) {
            const $button = $(this);
            toggleCollapse(findPanel($button));

            event.preventDefault();
        });

        $(document).on('keydown', '[role=tab]', function handleKeydown(event) {
            if (!/^(?:32|37|38|39|40)$/.test(event.which)) {
                return;
            }

            const $button = $(this);
            const $accordion = $button.closest('[role=tablist]');
            if ($accordion.length === 0) {
                return;
            }

            const spaceKey = 32;
            if (event.which === spaceKey) {
                $button.click();
            }

            const $buttons = $accordion.find('[role=tab]');
            const currentButtonFocusIndex = $buttons.index($buttons.filter(':focus'));

            const upKey = 38;
            const leftKey = 37;
            const downKey = 40;
            const rightKey = 39;

            let index;
            if (event.which === upKey || event.which === leftKey) {
                index = currentButtonFocusIndex - 1;
            } else if (event.which === downKey || event.which === rightKey) {
                index = currentButtonFocusIndex + 1;
            }

            if (index < 0) {
                index = $buttons.length - 1;
            } else if (index === $buttons.length) {
                index = 0;
            }

            $buttons.eq(index).focus();

            event.preventDefault();
            event.stopPropagation();
        });
    }();

    void function addMobileNavigationLinks() {
        const $nav = $('.js-nav-wrap');
        const $navItems = $nav.find('.js-nav li');
        $navItems.map((i, navItem) => $(navItem))
                 .each((i, $navItem) => {
                    const $link = $navItem.children('a');
                    const $childList = $navItem.children('ul');
                    if ($childList.length === 0) {
                        return;
                    }

                    $navItem.addClass('navigation--page__root-item-toggle js-nav-toggle');
                    $childList.prepend($('<li>', { 'class': 'navigation--page navigation--page__root-item js-nav-root', }).append($('<a>', { text: $link.text(), href: $link.attr('href'), })));
                    $childList.append($('<li>', { 'class': 'navigation--back-button js-nav-back', }).append($('<button>', { text: 'Back', })));
                 });
    }();

    void function mobileNavigationFlyout() {
        const $nav = $('.js-nav');
        const $topNavItems = $nav.find('.navigation > li');
        const desktopBreakPoint = 1000;

        // set the initial height of the nav wrapper
        // initialFontSize removed and set to 1em so that the correct height is set when initialized in desktop
        $topNavItems.css('font-size', '1em');
        $nav.height($topNavItems.length * $topNavItems.height());
        $topNavItems.attr('style', '');

        $nav.on('click', '.js-nav-toggle > a', function handleRootItemClick(event) {

            if(window.innerWidth < desktopBreakPoint) {
                const $link = $(this);
                const $navItem = $link.closest('li');
                const $parentList = $navItem.parent('ul');
                const $childList = $navItem.children('ul');
                const $childListChildren = $childList.find('> li');

                $childList.attr('aria-expanded', true);
                $parentList.toggleClass('show-sub-nav');
                $nav.height($childListChildren.length * $childListChildren.height());

                event.preventDefault();
            }
         });

         $nav.on('click', '.js-nav-back', function handleBackClick(event) {
            if(window.innerWidth < desktopBreakPoint) {
                const $backButton = $(this);
                const $list = $backButton.closest('ul');
                const $parentList = $list.parents('ul').first();
                const $parentListChildren = $parentList.find('> li');

                $list.attr('aria-expanded', false);
                $parentList.toggleClass('show-sub-nav');
                $nav.height($parentListChildren.length * $parentListChildren.height());

                event.preventDefault();
            }
         });
    }();

    $('a').filter(function FilterExternalLinks() {
        return this.hostname && !this.hostname.includes('gha.org');
    }).attr('target', '_blank');

    $('.gha').find('.DF-FieldRow').each((i, row) => {
        const $row = $(row);
        if ($row.find('input').length > 0 || $row.find('select').length > 0) {
            $row.addClass('js-hasInput');
            if ($row.find('.dynamicforms_captcha').length > 0) {
                $row.addClass('js-hasCaptcha');
            }
        } else if ($row.find('label').length > 0) {
            $row.addClass('js-hasLabelOnly');
        }
    });

}(jQuery);
